import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import MessageIcon from '@mui/icons-material/Message';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import MicIcon from '@mui/icons-material/Mic';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WifiIcon from '@mui/icons-material/Wifi';
import BluetoothIcon from '@mui/icons-material/Bluetooth';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventIcon from '@mui/icons-material/Event';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SegmentIcon from '@mui/icons-material/Segment';
import MailIcon from '@mui/icons-material/Mail';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StorageIcon from '@mui/icons-material/Storage';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PeopleIcon from '@mui/icons-material/People';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import ChatIcon from '@mui/icons-material/Chat';
import SourceIcon from '@mui/icons-material/Source';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SecurityIcon from '@mui/icons-material/Security';
import GridViewIcon from '@mui/icons-material/GridView';
import { AdminPanelSettings, SmartToy } from '@mui/icons-material';

const iconMap: Record<string, React.ReactElement> = {
  home: <HomeIcon />,
  menu: <MenuIcon />,
  arrow_back: <ArrowBackIcon />,
  arrow_forward: <ArrowForwardIcon />,
  close: <CloseIcon />,
  search: <SearchIcon />,
  settings: <SettingsIcon />,
  add: <AddIcon />,
  edit: <EditIcon />,
  delete: <DeleteIcon />,
  save: <SaveIcon />,
  refresh: <RefreshIcon />,
  download: <DownloadIcon />,
  upload: <UploadIcon />,
  email: <EmailIcon />,
  phone: <PhoneIcon />,
  message: <MessageIcon />,
  notifications: <NotificationsIcon />,
  share: <ShareIcon />,
  favorite: <FavoriteIcon />,
  favorite_border: <FavoriteBorderIcon />,
  star: <StarIcon />,
  star_border: <StarBorderIcon />,
  bookmark: <BookmarkIcon />,
  bookmark_border: <BookmarkBorderIcon />,
  camera_alt: <CameraAltIcon />,
  mic: <MicIcon />,
  location_on: <LocationOnIcon />,
  wifi: <WifiIcon />,
  bluetooth: <BluetoothIcon />,
  folder: <FolderIcon />,
  folder_open: <FolderOpenIcon />,
  insert_drive_file: <InsertDriveFileIcon />,
  attach_file: <AttachFileIcon />,
  play_arrow: <PlayArrowIcon />,
  pause: <PauseIcon />,
  stop: <StopIcon />,
  skip_next: <SkipNextIcon />,
  skip_previous: <SkipPreviousIcon />,
  person: <PersonIcon />,
  group: <GroupIcon />,
  group_work: <GroupWorkIcon />,
  thumb_up: <ThumbUpIcon />,
  thumb_down: <ThumbDownIcon />,
  check: <CheckIcon />,
  error: <ErrorIcon />,
  warning: <WarningIcon />,
  info: <InfoIcon />,
  help: <HelpIcon />,
  check_box: <CheckBoxIcon />,
  check_box_outline_blank: <CheckBoxOutlineBlankIcon />,
  radio_button_checked: <RadioButtonCheckedIcon />,
  radio_button_unchecked: <RadioButtonUncheckedIcon />,
  visibility: <VisibilityIcon />,
  visibility_off: <VisibilityOffIcon />,
  zoom_in: <ZoomInIcon />,
  zoom_out: <ZoomOutIcon />,
  calendar_today: <CalendarTodayIcon />,
  access_time: <AccessTimeIcon />,
  date_range: <DateRangeIcon />,
  event: <EventIcon />,
  lock: <LockIcon />,
  lock_open: <LockOpenIcon />,
  power_settings_new: <PowerSettingsNewIcon />,
  exit_to_app: <ExitToAppIcon />,
  assessment: <AssessmentIcon />,
  dashboard: <DashboardIcon />,
  segment: <SegmentIcon />,
  mail: <MailIcon />,
  account_tree: <AccountTreeIcon />,
  calendar_month: <CalendarMonthIcon />,
  storage: <StorageIcon />,
  directions_car: <DirectionsCarIcon />,
  file_download: <FileDownloadIcon />,
  manage_accounts: <ManageAccountsIcon />,
  people: <PeopleIcon />,
  request_page: <RequestPageIcon />,
  generated_by_ai: <AutoAwesomeIcon />,
  directions_run: <DirectionsRunIcon />,
  chat: <ChatIcon />,
  source: <SourceIcon />,
  // New icons for operations
  LOCAL_OFFER: <LocalOfferIcon />,
  DIRECTIONS_CAR: <DirectionsCarIcon />,
  DIRECTIONS_CAR_FILLED: <DirectionsCarIcon />,
  ATTACH_MONEY: <AttachMoneyIcon />,
  STAR: <StarIcon />,
  trending_down: <TrendingDownIcon />,
  track_changes: <TrackChangesIcon />,
  analytics: <AnalyticsIcon />,
  security: <SecurityIcon />,
  smart_toy: <SmartToy />,
  admin_panel_settings: <AdminPanelSettings />,
  apps: <GridViewIcon />,
};

/** Icon keys available for sidebar/navigation (picker should only show these) */
export const MATERIAL_ICON_KEYS: string[] = Object.keys(iconMap);

export function getMaterialIconComponent(
  iconName: string,
  sx?: any,
): React.ReactElement | null {
  const icon = iconMap[iconName];
  if (!icon) return null;
  // Optionally allow passing sx prop for sizing
  return React.cloneElement(icon, sx ? { sx } : {});
}
